import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "@/data/content";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServicesGrid({ compact = false }) {
  const items = compact ? SERVICES.slice(0, 6) : SERVICES;
  return (
    <section data-testid="services-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow">/ 01 · What we do</div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-white">
            A full-stack DevOps &amp; <span className="text-gradient">DevSecOps</span> partner.
          </h2>
          <p className="mt-5 text-slate-400 max-w-2xl text-lg">
            Nine focused practice areas — one accountable team. From landing zones to
            zero-downtime cutovers, we own the outcome end-to-end.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group relative overflow-hidden rounded-2xl glass p-7 hover:border-cyan-400/30 hover:shadow-[0_0_50px_-10px_rgba(0,229,255,0.35)] transition-all"
                data-testid={`service-card-${s.slug}`}
              >
                <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-cyan-500/10 blur-3xl opacity-0 group-hover:opacity-100 transition" />
                <div className="flex items-center justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500/20 to-violet-500/20 border border-white/10">
                    <Icon size={20} className="text-cyan-300" />
                  </div>
                  <span className="font-mono-plex text-[10px] tracking-[0.2em] uppercase text-slate-500">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl md:text-2xl font-semibold text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-400 text-[15px] leading-relaxed">{s.summary}</p>
                <ul className="mt-5 space-y-1.5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex gap-2 items-start text-sm text-slate-300">
                      <span className="mt-2 h-1 w-1 rounded-full bg-cyan-400 shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="mt-6 inline-flex items-center gap-1.5 text-cyan-300 text-sm font-medium hover:text-cyan-200 group/link"
                >
                  Talk to an engineer
                  <ArrowUpRight size={14} className="group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5 transition-transform" />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
